export default __webpack_public_path__ + "static/media/celebration-dedication.8e351c76.webp";